// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hAWO567e {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
}
.yheRcB04 {
  border: 3px solid #e8e8e8;
  border-top-color: #1890ff;
  border-radius: 50%;
  -webkit-animation: xJqu1KiJ 0.8s linear infinite;
          animation: xJqu1KiJ 0.8s linear infinite;
}
.FNNhRF6D {
  width: 1.5rem;
  height: 1.5rem;
  border-width: 2px;
}
.bxGBXejR {
  width: 2.5rem;
  height: 2.5rem;
  border-width: 3px;
}
.SD6Ai7ZZ {
  width: 3.75rem;
  height: 3.75rem;
  border-width: 4px;
}
@-webkit-keyframes xJqu1KiJ {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes xJqu1KiJ {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loading/Loading.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EC0BE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;ED1BA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,SAAA;EACA,eAAA;AAAF;AAGA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;UAAA,wCAAA;AADF;AAIA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AAFF;AAKA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AAHF;AAMA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAJF;AAOA;EACE;IACE,iCAAA;YAAA,yBAAA;EALF;AACF;AAEA;EACE;IACE,iCAAA;YAAA,yBAAA;EALF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.loading {\n  .flex-center();\n  flex-direction: column;\n  gap: @spacing-md;\n  padding: @spacing-lg;\n}\n\n.spinner {\n  border: 3px solid @border-color;\n  border-top-color: @primary-color;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.small {\n  width: 1.5rem; // 24px\n  height: 1.5rem; // 24px\n  border-width: 2px;\n}\n\n.medium {\n  width: 2.5rem; // 40px\n  height: 2.5rem; // 40px\n  border-width: 3px;\n}\n\n.large {\n  width: 3.75rem; // 60px\n  height: 3.75rem; // 60px\n  border-width: 4px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `hAWO567e`,
	"spinner": `yheRcB04`,
	"spin": `xJqu1KiJ`,
	"small": `FNNhRF6D`,
	"medium": `bxGBXejR`,
	"large": `SD6Ai7ZZ`
};
export default ___CSS_LOADER_EXPORT___;
